import { render, staticRenderFns } from "./TrustPaper.vue?vue&type=template&id=0b66a95e&scoped=true"
import script from "./TrustPaper.vue?vue&type=script&lang=js"
export * from "./TrustPaper.vue?vue&type=script&lang=js"
import style0 from "./TrustPaper.vue?vue&type=style&index=0&id=0b66a95e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b66a95e",
  null
  
)

export default component.exports